import axios from "axios";

export default axios.create({
    baseURL:  "https://api.administracion.cfl401areco.edu.ar", //"http://localhost:8080", //
    headers: {

        "Content-type": "application/json"
    }
});